import { batch, useDispatch } from 'react-redux';
import { TrackEvent } from '@alycecom/services';

import { initSegmentIdentity } from '../store/globalSettings/globalSettings.actions';

export interface IUseInitSegmentParams {
  isDataReady: boolean;
  payload: {
    id: string;
    traits?: Record<string, unknown>;
    options?: Record<string, unknown>;
  };
}

export const useInitSegments = ({ isDataReady, payload }: IUseInitSegmentParams): void => {
  const dispatch = useDispatch();

  const { trackEvent } = TrackEvent.useTrackEvent();

  if (isDataReady) {
    batch(() => {
      dispatch(TrackEvent.actions.setIdentity(payload));
      dispatch(
        TrackEvent.actions.addUserProperties({
          is_recipient_user: true,
          subscriptionStatus: 'inactive',
        }),
      );
      dispatch(initSegmentIdentity());
      trackEvent('Api - Loaded users data');
    });
  }
};
